import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { tutorAvailabilityService } from "@data/services/tutorAvailabilityService"

const initialState = {
    // The « Ma dispo » week view (semaine-type + open/engaged state + freshness),
    // as returned by every availability endpoint.
    weekView: null,
    // The server's verdict on a « Libérer des créneaux » draft, cleared as soon as
    // another one is asked for so a stale verdict is never shown as the current one.
    releasePreview: null,
}

/**
 * All « Ma dispo » endpoints (get / confirm / starting-date) return the same week
 * view, so each SUCCESS replaces it. Reset on logout to avoid leaking the previous
 * tutor's slots.
 */
export function tutorAvailability(state = initialState, action) {
    switch (action.type) {
        case tutorAvailabilityService.getAvailability.name + apiConstants._SUCCESS:
        case tutorAvailabilityService.confirmWeek.name + apiConstants._SUCCESS:
        case tutorAvailabilityService.updateStartingDate.name + apiConstants._SUCCESS:
            return { ...state, weekView: action.data }

        case tutorAvailabilityService.previewSlotRelease.name + apiConstants._REQUEST:
            return { ...state, releasePreview: null }
        // The release returns the week it leaves: no second fetch.
        case tutorAvailabilityService.releaseSlots.name + apiConstants._SUCCESS:
            return { ...state, weekView: action.data.week_view, releasePreview: null }
        case tutorAvailabilityService.previewSlotRelease.name + apiConstants._SUCCESS:
            return { ...state, releasePreview: action.data }

        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}
